import { InputHTMLAttributes, JSX } from 'react';

import { clsx } from 'clsx';

import { Radio, Utils } from '@treezor/design-system';

type TRadioCard = InputHTMLAttributes<HTMLInputElement> & {
  icon: JSX.Element;
  isSelected: boolean;
  title: string;
  value: string;
  isDisabled?: boolean;
  description?: string;
  className?: string;
  handleChange?: (value: string) => void;
};

export const RadioCard = ({
  icon,
  title,
  value,
  description = '',
  isSelected = false,
  isDisabled = false,
  handleChange,
  className,
  ...props
}: TRadioCard) => {
  const cardClassname = clsx(
    'transition-shadow group flex flex-col items-start gap-4 w-min min-w-[250px] rounded-400 bg-primary border-2 p-6 border-primary cursor-pointer min-h-full',
    isSelected && 'shadow-100',
    isDisabled && 'cursor-auto !shadow-0',
    className,
  );

  return (
    <label className="flex flex-col gap-4 w-fit">
      <div className={cardClassname}>
        <div className="flex w-full items-start justify-between">
          <div className={`${isDisabled && 'opacity-[0.46]'}`}>{icon}</div>
          <Radio isSelected={isSelected} isDisabled={isDisabled} handleChange={handleChange} value={value} {...props} />
        </div>
        <div className="flex flex-col gap-3 w-full h-full">
          <h4 className={clsx('typo-h5-bold', isDisabled ? 'text-disabled' : 'group-hover:text-interactive')}>
            {title}
          </h4>
          {description && (
            <span className={clsx('typo-body-regular-paragraph', isDisabled && 'text-disabled')}>
              {Utils.truncateLabel(description, 80)}
            </span>
          )}
        </div>
      </div>
    </label>
  );
};
